import { handleActions } from "redux-actions";
import { SET_PAGE_NAME, UNKNOWN_PAGE } from "./constants";

export const initialState = {
  name: UNKNOWN_PAGE
};

export default handleActions(
  {
    [SET_PAGE_NAME]: (state, action) => ({
      ...state,
      name: action.payload
    })
  },
  initialState
);
